module.exports = __webpack_public_path__ + "img/image--219.066f6e23.jpg";